import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, Injector, OnDestroy, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog'; // dialog
import { Router } from '@angular/router';
import { LoginStoreEffects } from '@app/root-store/login-store/effects';
import { RelationshipStoreEffects } from '@app/root-store/relationship-store/effects';
import { VaultStoreEffects } from '@app/root-store/vault-store/effects';
import { SharedConfirmationDialogComponent } from '@app/shared/component/shared-confirmation-dialog/shared-confirmation-dialog.component';
import { UserInviteComponent } from '@app/shared/component/user-invite/user-invite.component';
import { AuthService, CommonService, DocumentService, UserConnectionService } from '@app/shared/services';
import { ScriptService } from '@app/shared/services/script/script.service';
import { ShareService } from '@app/shared/services/vault/share.service';
import { stringDateToDatabase } from '@app/shared/utils';
import { Store } from '@ngrx/store';
import { ToastrService } from 'ngx-toastr';
import { exit } from 'process';
import { Subscription } from 'rxjs';
import { map } from 'rxjs/internal/operators/map';
import { startWith } from 'rxjs/operators';
import * as selectors from '../../../../root-store/relationship-store/relationship.selector';
import { FolderEncryptedSuccessComponent } from '../dialogs/folder-encrypted-success/folder-encrypted-success.component';
import { AccessManagerBase } from './shared/access-manager.base';
import { NotifySharingUpdateService } from '@app/shared/services/notify-sharing-update/notify-sharing-update.service';
import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';

@AutoUnsubscribe()
@Component({
  selector: 'my-information-manager',
  templateUrl: './access-manager.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MyInformationManagerComponent extends AccessManagerBase implements OnInit, OnDestroy {
  recordCount;
  allUser;
  relationshipObject$;
  relationshipObject;
  isPageLoaded = false;
  testcheckr;
  currentUser;
  myVaultStateObject$;
  allRelationship = [];
  stateObject;
  subscription = new Subscription();

  constructor(
    private injector: Injector,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private cd: ChangeDetectorRef,
    private authService: AuthService,
    private router: Router,
    private relationshipService: RelationshipStoreEffects,
    private store: Store,
    private commonService: CommonService,
    private userConnectionService: UserConnectionService,
    private vaultShareService: ShareService,
    private dialog: MatDialog,
    private loginService: LoginStoreEffects,
    private toastr: ToastrService,
    private vaultService: VaultStoreEffects,
    private script: ScriptService,
    notifySharingUpdateService: NotifySharingUpdateService
  ) {
    super(authService, router, commonService, userConnectionService, dialog, vaultService, script, cd, notifySharingUpdateService);
    this.title = 'Share Information';
    this.addShowButtonText = 'Share';
    this.currentSectionTitle = 'Shared With';
    this.connectionPlaceholderText = 'Search your network or send an invitation';
    this.emptyExistingUsersText = 'You are not currently sharing this information with any user.';
    this.emptyConnectionText = `You don't have any relationships with whom you can share`;
    this.showShareButton = true;
    this.showShareTypeOptions = true;
    this.sharedObjectType = 'information';
    this.dialogName = 'Sharing';
    this.zerostateTextMobile = 'You are not currently not sharing this information with any user.';
    this.mobileText = 'Search network';
    this.isShareFolder = true;

    this.subscription.add(
      this.loginService.loginObject.subscribe((state) => {
        if (state?.data) {
          this.currentUser = state?.data;
        }
      })
    );
    this.myVaultStateObject$ = this.vaultService.vaultObject;
    this.subscription.add(
      this.myVaultStateObject$.subscribe((data) => {
        this.stateObject = data;
      })
    );
  }

  test(value) {
    if (this.allUser) {
      return this.allUser.filter((user) => user.full_name.toLowerCase().includes(value.toLowerCase()));
    }
  }
  async ngOnInit() {
    if (this.inlineComponent && this.nonDialogModalData) {
      this.modalData = this.nonDialogModalData;
    } else {
      this.parentDialogRef = this.injector.get(MatDialogRef<MyInformationManagerComponent>);
      this.modalData = this.data;
    }

    this.relationshipObject$ = this.relationshipService.relationshipObject;
    this.objectName = this.adminName ? `${this.adminName}` : 'My Vault ';

    this.sharingTitle = this.stateObject?.vaultName ? `${this.stateObject?.vaultName}` : 'My Vault';
    this.sharingSubtitle = `Manage Sharing and Accessibility for ` + this.sharingTitle;

    this.recordCount = this.modalData?.recordCount;

    this.subscription.add(
      this.connectionUserFormControl.valueChanges
        .pipe(
          startWith(''),
          map((value) => this.test(value))
        )
        .subscribe((response) => {
          this.users = response;
        })
    );

    await this.getExistingUser();

    // this.superNgOnInit();
  }

  async getExistingUser() {
    //get a list of existing users who have been shared this information
    const vaultId = this.modalData?.vaultId ? this.modalData.vaultId : this.vaultStateObject?.vaultId ? this.vaultStateObject.vaultId : null;
    await new Promise<void>((resolve) => {
      this.subscription.add(
        this.vaultShareService.getVaultShareInformation(this.vaultStateObject.userId, vaultId).subscribe((results) => {
          results.forEach((element, index) => {
            element.name = element?.user_first_name + ' ' + element?.user_last_name;
          });
          this.subscription.add(
            this.store.select(selectors.getrelationshipnameList(results)).subscribe((item) => {
              this.existingUsers = item;
              this.allConnection();
              this.cd.markForCheck();
              resolve();
              this.showLoader = false;
            })
          );
        })
      );
    });
  }

  allConnection() {
    this.subscription.add(
      this.store.select(selectors.getAllUserListWithApprovedPending()).subscribe((data) => {
        const finalData = [];
        data.forEach((element) => {
          if (this.existingUsers.findIndex((x) => x.user_id == element.user_id) == -1) {
            var test = JSON.parse(JSON.stringify(element));
            test.id = element?.user_id;
            test.name = element.user_first_name + ' ' + element.user_last_name;
            Object.preventExtensions(test);
            finalData.push(test);
          }
        });
        this.manipulateDate(finalData);
      })
    );
  }

  manipulateDate(data) {
    this.cd.markForCheck();
    this.users = [
      ...data.map(({ id, user_id, name, from_user_id, relationship_name, user_profile_image_url, connection_status }) => ({
        id,
        user_id,
        name,
        from_user_id,
        relationship_name,
        user_profile_image_url,
        connection_status,
      })),
    ];
    this.allUser = [...data];
    this.cd.detectChanges();
  }

  selectConnectedUser(userData) {
    // if ($event.source.selected) {
    this.addUserAsShare(userData);
    // }
  }

  addUserAsShare(userData) {
    this.selectedUser = userData;
    this.isUserSelected = true;
    this.addUserSharewithUser();
  }

  async addUserSharewithUser() {
    let didCancel = false;
    await new Promise<void>((resolve, error) => {
      this.launchNewShareOptionsDialog(
        () => {
          resolve();
        },
        () => {
          error();
        }
      );
    }).catch(() => {
      didCancel = true;
    });

    if (didCancel) {
      //clear selection from mat auto complete
      this.clearAutoCompleteValue();

      exit;
    }

    if (!this.newShareTypeDetails) {
      //if no options have been selected set defaults
      this.newShareTypeDetails = { share_date: new Date(Date.now()).toLocaleDateString(), is_sealed: false };
    }

    let obj = {
      connection_status: this.selectedUser.connection_status,
      is_sealed: this.newShareTypeDetails.is_sealed,
      is_editable: this.newShareTypeDetails.is_editable,
      share_date: this.newShareTypeDetails.share_date ? stringDateToDatabase(this.newShareTypeDetails.share_date) : null,
      end_date: this.newShareTypeDetails.end_date ? stringDateToDatabase(this.newShareTypeDetails.end_date) : null,
      shared_with_user_id: this.selectedUser.user_id,
      user_id: this.vaultStateObject.userId,
      vault_id: this.modalData?.vaultId ? this.modalData.vaultId : this.vaultStateObject?.vaultId ? this.vaultStateObject.vaultId : null,
    };
    if (obj['vault_id'] == null) {
      delete obj['vault_id'];
    }
    this.subscription.add(
      this.vaultShareService.createVaultShareInformation(obj).subscribe(async (results) => {
        if (results?.securityKey) {
          this.dialog.open(FolderEncryptedSuccessComponent, {});
        }
        this.toastr.success(`${this.objectName}'s Folder shared with ${this.selectedUser.name}`);
        await this.getExistingUser();
        //this.getAllConnections();

        //clear selection from mat auto complete
        this.clearAutoCompleteValue();

        //refresh modal
        this.cd.detectChanges();
      })
    );
  }

  Invite() {
    this.isPageLoaded = true;
    const data = {
      disableSelectionOption: true,
      custom_user_type: 'normal',
    };
    const modalRef = this.dialog.open(UserInviteComponent, {
      autoFocus: false,
      data: data,
      panelClass: 'full-window-dialog-2-mobile-responsive',
    });
    this.subscription.add(
      modalRef.afterClosed().subscribe((res) => {
        if (res?.success && res?.isexistingUser) {
          this.subscription.add(
            this.relationshipObject$.subscribe((data) => {
              this.relationshipObject = data;
              this.allRelationship = data['allRelationships'];
              if (this.allRelationship != null && this.allRelationship.length && this.isPageLoaded) {
                let index = this.allRelationship.findIndex((x) => x.to_user_id == res.user['to_user_id']);
                if (index != -1) {
                  this.isPageLoaded = false;
                  this.addUserAsShare(this.allRelationship[index]);
                }
              }
            })
          );
        } else if (res?.success && !res?.isexistingUser) {
          // eslint-disable-next-line eslint-rules/no-unmanaged-subscriptions
          this.testcheckr = this.relationshipObject$.subscribe((data) => {
            this.relationshipObject = data;
            this.allRelationship = data['allRelationships'];
            if (this.allRelationship != null && this.allRelationship.length && this.isPageLoaded) {
              let index = this.allRelationship.findIndex((x) => x.to_user_id == res.user['id']);
              if (index != -1) {
                this.isPageLoaded = false;
                this.addUserAsShare(this.allRelationship[index]);
                this.testcheckr.unsubscribe();
              }
            }
          });
        }
        this.cd.detectChanges();
      })
    );
  }

  deleteExistingUser(existingUser) {
    const sharedDialogRef = this.dialog.open(SharedConfirmationDialogComponent, {
      width: '400px',
      data: {
        title: 'Delete',
        materialIcon: 'delete',
        text: `Are you sure you want to delete this user's access to this information?`,
        proceedTitle: 'Delete',
      },
    });

    this.subscription.add(
      sharedDialogRef.afterClosed().subscribe((confirmation) => {
        if (confirmation) {
          this.subscription.add(
            this.vaultShareService
              .deleteVaultShareInformation({
                user_id: this.vaultStateObject.userId,
                id: existingUser.vault_user_share_id,
              })
              .subscribe((results) => {
                this.toastr.success(`${existingUser.user_first_name}'s access removed for ${this.objectName}`);

                this.getExistingUser();
                // this.getAllConnections();

                //refresh modal
                this.cd.markForCheck();
              })
          );
        }
      })
    );
  }

  updateExistingUser(value, existingUser) {
    this.subscription.add(
      this.vaultShareService
        .updateVaultShareInformation({
          id: existingUser.vault_user_share_id,
          is_sealed: value.is_sealed,
          share_date: value.share_date,
          end_date: value.end_date,
          user_id: this.vaultStateObject.userId,
          is_editable: value.is_editable,
        })
        .subscribe(async (results) => {
          //add toastr message once update is done.
          this.toastr.success(`${existingUser.user_first_name}'s access updated for ${this.objectName}`);
          await this.getExistingUser();
          //refresh modal
          this.cd.markForCheck();
        })
    );
  }

  shareTypeUpdated(value) {
    this.newShareTypeDetails = value;
  }

  setShareDetails(existingUser) {
    return {
      ...existingUser,
      end_date: existingUser.vault_user_share_end_date,
      share_date: existingUser.vault_user_share_share_date,
      is_sealed: existingUser.vault_user_share_is_sealed,
      is_editable: existingUser.vault_user_share_is_editable,
    };
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
    this.isPageLoaded = false;
  }
}
